/**
 * 依頼に関する定数
 */

/** @type {number} 依頼可能開始時刻 */
export const begin = 9

/** @type {number} 依頼可能終了時刻 */
export const end = 21

/** @type {number} 依頼可能時刻間隔 */
export const span = 1
